<script lang="ts">
import { applyAction, enhance } from '$app/forms'
import { currentAppUser, pocketbase } from '$lib/pocketbase'
export let buttonClass ="btn-ai"
</script>

<form
method="POST"
action="/auth/logout"
use:enhance={() => {
  return async ({ result }) => {
    pocketbase.authStore.clear()
    await applyAction(result)
    currentAppUser.set(null)
  }
}}
>
<button class={buttonClass}>Log out</button>
</form>
